import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";
import { BasicDoc, Hit } from "react-instantsearch-core";

import HitCard from "../hit/hitcard";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "inline-block",
    flex: 1,
  },
  gridItem: {
    minHeight: 356,
    height: "auto",
  },
}));

const HitsGrid: React.FunctionComponent<any> = (props) => {
  const { hits }: { hits: Hit<BasicDoc>[] } = props;
  const classes = useStyles();
  
  return (
    <Grid container spacing={2}>
      {hits.map((hit: Hit<BasicDoc>, i: number): JSX.Element => {
        return (
          <Grid key={`hit-${hit.id}`} item xs={12} sm={6} md={4} lg={4} xl={4} className={classes.gridItem + ' new-icon-padding new-icon-grid'}>
            <HitCard className={classes.card} hit={hit} headingLevel="h2" />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default HitsGrid;
